/// <amd-module name="TFS/Samples/GlobalMessages/GlobalMessagesSamples" />
import * as React from "react";

import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";
import { Button } from "VSSUI/Button";

interface GlobalDialogSampleProps {}

export class MessagesSamples extends VssComponent<GlobalDialogSampleProps> {
    private messagesService: IGlobalMessagesService;

    private queuedDialogCount: number = 1;
    private queuedToastCount: number = 1;
    private overrideToastCount: number = 1;

    constructor(props: GlobalDialogSampleProps, context: IVssComponentContext) {
        super(props, context);

        this.messagesService = context.pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
    }

    public render() {
        return (
            <div className="flex-column">
                <Button onClick={this.onAddDialog}>Click to add a Dialog</Button>
                <Button onClick={this.onReplaceDialog}>Click to replace current Dialog</Button>
                <Button onClick={this.onQueueToast}>Click to Queue a Toast</Button>
                <Button onClick={this.onOverrideToast}>Click to Override Current Toast</Button>
            </div>
        );
    }

    private onAddDialog = () => {
        this.messagesService.addDialog({
            message: "Dialog Added",
            title: "Dialog " + this.queuedDialogCount,
            buttonProps: [{ primary: true, text: "Accept" }]
        });

        this.queuedDialogCount += 1;
    };

    private onReplaceDialog = () => {
        this.messagesService.addDialog(
            {
                message: "Dialog replaced ",
                title: "Dialog " + this.queuedDialogCount
            },
            true
        );

        this.queuedDialogCount += 1;
    };

    private onQueueToast = () => {
        this.messagesService.addToast({
            message: "Queued Toast " + this.queuedToastCount,
            duration: 2000,
            callToAction: "Call to Action",
            onCallToActionClick: this.onCallToActionClick
        });

        this.queuedToastCount += 1;
    };

    private onOverrideToast = () => {
        this.messagesService.addToast({
            message: "Override Toast " + this.overrideToastCount,
            duration: 2000,
            forceOverrideExisting: true,
            callToAction: "Call to Action",
            onCallToActionClick: this.onCallToActionClick
        });

        this.overrideToastCount += 1;
    };

    private onCallToActionClick = () => {
        alert("Call to Action clicked");
    };
}

Components.add("messages-sample-view", MessagesSamples);
